import { updateState, withDevtools, withFeatureFactory } from '@angular-architects/ngrx-toolkit';
import { computed, inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { setPageNumber, setPageSize, withPagination, withPaginationMethods } from '@shared/state/pagination.feature';
import { setError, setFulfilled, setPending, withRequestStatus } from '@shared/state/request-status.feature';
import { pipe, switchMap, tap } from 'rxjs';
import { OrganizationAdmin } from '../../../user/data-access-users/model/organization-admin.model';
import { FilterSuborganizationRequest } from '../model/filter-suborganization-request.model';
import { SuborganizationService } from '../service/suborganization.service';

export const SuborganizationStore = signalStore(
  withDevtools('suborganizations'),
  withState({
    data: null as OrganizationAdmin[] | null,
  }),
  withRequestStatus(),
  withFeatureFactory((store) => withPagination<OrganizationAdmin>(store.data)),
  withComputed(({ data }) => ({
    suborganizations: computed(() => data()),
  })),
  withMethods((store, suborganizationService = inject(SuborganizationService)) => ({
    load: rxMethod<FilterSuborganizationRequest>(
      pipe(
        tap(({ pageNumber, pageSize, enableGlobalLoader }) => {
          if (!enableGlobalLoader) {
            updateState(store, '[SuborganizationStore] Set pending', setPending());
          }
          updateState(store, '[SuborganizationStore] Set page number', setPageNumber(pageNumber));
          updateState(store, '[SuborganizationStore] Set page size', setPageSize(pageSize));
        }),
        switchMap(({ organizationId, ordering, sortDirection, enableGlobalLoader }) =>
          suborganizationService
            .getSuborganizations({
              organizationId,
              ordering,
              sortDirection,
              pageSize: store.pageSize(),
              pageNumber: store.pageNumber(),
              enableGlobalLoader,
            })
            .pipe(
              tapResponse({
                next: (data) => {
                  updateState(store, '[SuborganizationStore] Set fulfilled', setFulfilled());
                  updateState(store, '[SuborganizationStore] Set data', { data });
                },
                error: () => {
                  updateState(store, '[SuborganizationStore] Set error', setError());
                  updateState(store, '[SuborganizationStore] Set data', { data: null });
                },
              }),
            ),
        ),
      ),
    ),
  })),
  withFeatureFactory((store) => withPaginationMethods(store)),
);
